import {
  isAttributesChanged,
  resolveEntityTagAssociationId,
} from "./TagAttributeModal.logic";

export const shouldPersistNewTag = (isNewTag: boolean) => isNewTag === true;

export const shouldPersistTagValue = ({
  isNewTag,
  editMode,
  entityTag,
  updatedAttributes,
  displayValue,
}: {
  isNewTag?: boolean;
  editMode?: boolean;
  entityTag?: {
    displayValue?: string;
    tag?: { attributes?: unknown };
  };
  updatedAttributes?: unknown;
  displayValue?: string;
}) =>
  !isNewTag &&
  !!editMode &&
  (isAttributesChanged(entityTag?.tag?.attributes, updatedAttributes) ||
    displayValue !== entityTag?.displayValue);

export const entityTagAssociationIdToPersist = (
  entityTag: { id?: string; tagId?: string; tag?: { id?: string } } | undefined,
  previousEntityTagAttributes: unknown,
  updatedEntityTagAttributes: unknown
) => {
  const entityTagAssociationId = resolveEntityTagAssociationId(entityTag);
  if (
    !entityTagAssociationId ||
    !isAttributesChanged(
      previousEntityTagAttributes,
      updatedEntityTagAttributes
    )
  ) {
    return undefined;
  }
  return entityTagAssociationId;
};
